import React, {useCallback, useMemo, useState, useEffect } from "react";
import {useHistory, useParams, useLocation} from 'react-router-dom';
import Prev from "../../assets/image/icon_prev.svg"
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import useFetch from "@common/hooks/fetch/useFetch";
import {getJournalDetail, getJournalSectionList} from "@common/services/restapi/journal";
import {Moments} from "@common/utils/date/moments";

function MagazineDetailView() {
  const history = useHistory();
  const { magazineId } = useParams();

  const {data: journalSectionList} = useFetch(() => getJournalSectionList(), [], []);
  const {data: detailView} = useFetch(() => getJournalDetail({ukey: magazineId}), [], {});

  const sectionTitle = useMemo(() => {
    if (journalSectionList.length > 0 && detailView) {
      const findJournal = journalSectionList.find(journal => journal.ukey === detailView.sectionUkey);
      if (findJournal) {
        return findJournal.name;
      }
    }
    return "";
  }, [journalSectionList, detailView]);


  const handleGoBack = useCallback(() => {
    history.goBack();
  },[]);

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">매거진</h3>
      </div>

      {
        detailView &&
        <div className="common-body--content">
          <div className="header-box">
            <div className="publisher">{sectionTitle}</div>
            <h4 className="title">{detailView.title}</h4>
            <div className="row-box">
              <div className="view-count">
                <img src={ViewIcon} alt=""/>
                <span>{detailView.rcount}</span>
              </div>
              <img src={Split} alt=""/>
              <div className="created-date">{Moments.Format(detailView.wdate, 'yyyy.MM.DD')}</div>
            </div>
            {/*<div className="row-box-right">
              <span className="author">글 박두현 책임</span>
              <img src={Split} alt="" className="split"/>
              <div className="company">HS애드</div>
            </div>*/}
          </div>
          <div className="body-box">
            <div className="content-box">
              {/*<img src={detailView.thumbnail} alt=""/>*/}
              <p className="summary" dangerouslySetInnerHTML={{ __html: detailView.content }}/>
            </div>
          </div>
        </div>
      }
    </>

  )
}

export default MagazineDetailView;
